module.exports = __webpack_public_path__ + "img/18.6f9432f3.png";